var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import { mergeObjects } from '../../helpers';
import { GeebeeComponentsContext } from './ComponentsWrapper';
var LabelWrapper = function (props) {
    var _a;
    var contextLabelProps = useContext(GeebeeComponentsContext);
    var _b = mergeObjects(props, (_a = contextLabelProps === null || contextLabelProps === void 0 ? void 0 : contextLabelProps.labelProps) !== null && _a !== void 0 ? _a : {}), children = _b.children, required = _b.required, label = _b.label, _c = _b.classNames, classNames = _c === void 0 ? '' : _c, _d = _b.disabled, disabled = _d === void 0 ? false : _d, typographyProps = _b.typographyProps;
    if (typeof label === 'undefined')
        return children;
    return (React.createElement("div", { className: "lfc-component-container" },
        React.createElement(Typography, __assign({ variant: "subtitle2", className: "!lfc-mb-2 ".concat(classNames, " ").concat(disabled ? 'lfc-text-gray-600' : '') }, typographyProps),
            label,
            " ",
            required && React.createElement("span", { className: 'lfc-text-error-500' }, "*")),
        children));
};
export default LabelWrapper;
//# sourceMappingURL=LabelWrapper.js.map